import React from "react";
import { Row, Col } from 'react-bootstrap'
import { ITrendingMenuData } from "../../types/api/dinningApi";
import { NoData } from "../common/NoData";
import { divideArray } from "../../utils/hepler";
import { useTranslation } from "react-i18next";
import { IDinning, ISubTrendingMenu } from "../../types/features/multiLanguageSlice";

const FoodMenu: React.FC<{ trending_menu: Array<ITrendingMenuData>, trending_menu_image: string }> = ({ trending_menu, trending_menu_image }) => {
    let menuData = { firstHalf: [], secondHalf: [] };
    if (trending_menu && trending_menu.length > 0) {
        menuData = divideArray(trending_menu);
    }
const {t} = useTranslation()
const trending_menu_json = t('dinning.trending_menu.trending_menus', { returnObjects: true })  as ISubTrendingMenu[];
console.log(trending_menu_json,'trending_menu_json');
console.log(menuData.firstHalf,'menuData.firstHalf');


    return (
        <div>
            <div>
                <section className="foodmenu-section">
                    <div className="container">
                        <div className="foodmenu-heading">
                            <h4 className="sub-title">{t('dinning.trending_menu.title')}</h4>
                            <h3 className="title">{t('dinning.trending_menu.sub_title')}</h3>
                        </div>
                        <Row>
                            <Col xs={{ span: 12, order: 2 }} md={{ span: 12, order: 2 }} lg={{ span: 4, order: 1 }}>
                                <div className="foodmenu-list">
                                    <ul>
                                        {
                                            menuData.firstHalf && menuData.firstHalf.length > 0 ?
                                                menuData.firstHalf.map((menu: ITrendingMenuData, index: number) => (
                                                    <li key={"Trending_Menu_" + index}>
                                                        <div className="foodmenu-body">
                                                            <div className="foodmenu-item">
                                                                <img src={require('../../assets/images/foodmenuitem-1.png')} alt="img" className="img-fluid" ></img>
                                                                <div className="foodmenu-content">
                                                                    <h5>{trending_menu_json && trending_menu_json.length>0 && trending_menu_json[index].name}</h5>
                                                                    <p>{trending_menu_json && trending_menu_json.length>0 &&  trending_menu_json[index].description}</p>
                                                                </div>
                                                            </div>
                                                            <div className="item-price">
                                                                <p>${trending_menu_json && trending_menu_json.length>0 &&  trending_menu_json[index].price}</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )) : <NoData message="Oops, No Food Menu Data Found!!" />
                                        }
                                    </ul>
                                </div>
                            </Col>
                            <Col xs={{ span: 12, order: 1 }} md={{ span: 12, order: 1 }} lg={{ span: 4, order: 2 }}>
                                <div className="foodmenu-center">
                                    <img src={trending_menu_image} alt="img" className="img-fluid"></img>
                                </div>
                            </Col>
                            <Col xs={{ span: 12, order: 3 }} md={{ span: 12, order: 3 }} lg={{ span: 4, order: 3 }}>
                                <div className="foodmenu-list">
                                    <ul>
                                        {
                                            menuData.secondHalf && menuData.secondHalf.length > 0 ?
                                                menuData.secondHalf.map((menu: ITrendingMenuData, index: number) => (
                                                    <li key={"Trending_Menu_" + index}>
                                                        <div className="foodmenu-body">
                                                            <div className="foodmenu-item">
                                                                <img src={require('../../assets/images/foodmenuitem-1.png')} alt="img" className="img-fluid" ></img>
                                                                <div className="foodmenu-content">
                                                                    <h5>{trending_menu_json && trending_menu_json.length>0 && trending_menu_json[index].name}</h5>
                                                                    <p>{trending_menu_json && trending_menu_json.length>0 && trending_menu_json[index].description}</p>
                                                                </div>
                                                            </div>
                                                            <div className="item-price">
                                                                <p>${trending_menu_json && trending_menu_json.length>0 && trending_menu_json[index].price}</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )) : <NoData message="Oops, No Food Menu Data Found!!" />
                                        }
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default FoodMenu;